import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
//  Interface for Data table data type for all the columns
export interface Props {
  children?: FC;
  item?: AccountEventName;
}

interface AccountEventName {
  account?: string;
}
const EventsListAccountEventNameCell: FC<Props> = ({
  item = {
    account: '',
  },
}) => {
  const { account } = item;
  return (
    <DataTableCell title={account || ''}>
      <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{account}</p>
    </DataTableCell>
  );
};

/** Custom Account/Event Name cell */
export default EventsListAccountEventNameCell;
